











import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class Form extends Vue {
  @Prop() public id!: string;
}
